import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { DealerCountry } from 'src/app/models/dealer-country.model';
import { Dealer } from 'src/app/models/dealer.model';
import { AuthService } from 'src/app/services/auth.service';
import { ClickStreamService } from 'src/app/services/click-stream.service';
import { DealersService } from 'src/app/services/dealers.service';
import { UserService } from 'src/app/services/user.service';
import { plaintext } from '../../../assets/plaintext';

@Component({
  selector: 'app-side-panel',
  templateUrl: './side-panel.component.html',
  styleUrls: ['./side-panel.component.scss']
})
export class SidePanelComponent implements OnInit {
  
  language: string;
  dashButtonText: string
  reportButtonText: string;
  constructor(private userService : UserService, private dealersService : DealersService, private clickstream : ClickStreamService, private authService : AuthService) { 
    this.language = this.userService.user.language;
    this.dashButtonText = plaintext.dashboard.title[this.language];
    this.reportButtonText = plaintext.reports.title[this.language];
  }

  url : string;
  public viewDashboardAs : Dealer;
  private viewDashIdSubscription : Subscription;
  isAdmin : boolean;

  ngOnInit() {
    this.url = window.location.href;
    this.isAdmin = this.userService.user.isAdmin;
    this.viewDashIdSubscription = this.dealersService.observableViewAsId.subscribe(dealer => {
      this.viewDashboardAs = dealer;
    });
  }

  click(page) {
    this.clickstream.send('nav-click', 'click', page, 'Navigation', '', true);
  }

  logout() {    
    this.authService.signout();
  }

}
